import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import View from './View'

/**
 * `Entity.membershipTransaction` is VIEW-ONLY (ticket 537, comment #13) - a
 * transaction is a payment record, never created/updated/deleted from the
 * BO, so `formActions`/`handlers` only wire the `view` action.
 */
export const MembershipTransactionForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      formActions={{
        view: View,
      }}
      handlers={{}}
    />
  )
)

MembershipTransactionForm.displayName = 'MembershipTransactionForm'

export default MembershipTransactionForm
